import { render } from "./BtnArriveSchedule.vue?vue&type=template&id=166d35d9"
import script from "./BtnArriveSchedule.vue?vue&type=script&lang=js"
export * from "./BtnArriveSchedule.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__